var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'reflect-metadata';
import '@/global/bootstrap';
import 'focus-visible';
import { Vue, Component, Provide } from 'vue-property-decorator';
import ScrollLoader from 'vue-scroll-loader';
import AppToastPlugin from '@/plugins/AppToastPlugin';
// Register the router hooks with their names
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);
import VueApollo from 'vue-apollo';
import { IconsPlugin, VBTooltipPlugin } from 'bootstrap-vue';
import apolloClient from '@/graphql/apollo-client';
import { i18n } from './translations';
import { router } from './router';
import { store } from '@/modules/main/store';
import { ACTIONS } from '@/modules/main/store/sessionModule';
Vue.use(VueApollo);
Vue.use(IconsPlugin);
Vue.use(ScrollLoader);
Vue.use(AppToastPlugin);
Vue.use(VBTooltipPlugin);
// import app component
import JumpLink from '@/modules/main/components/JumpLink.vue';
import UserBar from '@/modules/main/components/UserBar.vue';
import SearchBar from '@/modules/main/components/SearchBar.vue';
import MainStage from '@/modules/main/components/MainStage.vue';
import SideNav from '@/modules/main/components/Nav/SideNav.vue';
import BrandBar from '@/modules/main/components/BrandBar.vue';
import MobileBrandBar from '@/modules/main/components/MobileBrandBar.vue';
import MobileSideNav from '@/modules/main/components/MobileSideNav.vue';
import NotificationsBar from '@/modules/main/components/NotificationsBar.vue';
import SimpleUsersModal from '@/modules/main/components/modals/SimpleUsersModal.vue';
import TimeoutManagerModal from '@/modules/main/components/modals/TimeoutManagerModal.vue';
import StaticPageAccordian from '@/modules/main/components/accordian/StaticPageAccordian.vue';
import NeighbourhoodList from '@/modules/main/components/NeighbourhoodList.vue';
import NeighbourhoodInformation from '@/modules/main/components/NeighbourhoodInformation.vue';
import CommunityList from '@/modules/main/components/CommunityList.vue';
import CommunityInformation from '@/modules/main/components/CommunityInformation.vue';
import MembershipInformation from '@/modules/main/components/MembershipInformation.vue';
import { GetSession, GetUserSimple } from '@/graphql/queries/users';
import { GetPostLikes } from '@/graphql/queries/posts';
import linkify from 'vue-linkify';
Vue.directive('linkified', linkify);
var apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.initialFocusedElementId = null;
        _this_1.sessionData = null;
        _this_1.likedUsers = [];
        _this_1.likedUsersLoading = false;
        _this_1.isMobileMenuOpen = false;
        _this_1.isMobileView = false;
        return _this_1;
    }
    Object.defineProperty(App.prototype, "session", {
        get: function () {
            var _this = this;
            return {
                get user() {
                    return _this.$store.state.session.user.data;
                },
                get notifications() {
                    return _this.$store.state.session.notifications;
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.loadSessionData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: GetSession,
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        this.sessionData = data;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.updateSessionCounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: GetUserSimple,
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        if (this.session.user && data) {
                            this.session.user.unread_notification_count = data.me.unread_notification_count;
                            this.session.user.unread_messages_count = data.me.unread_messages_count;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.updateNotificationCounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: GetUserSimple,
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        if (this.session.user && data) {
                            this.session.user.unread_notification_count = data.me.unread_notification_count;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.loadAndShowPostLikes = function (postUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.likedUsersLoading = true;
                        return [4 /*yield*/, this.$apollo.query({
                                query: GetPostLikes,
                                variables: { uuid: postUuid },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        if (data.response.likes.length) {
                            this.likedUsers = data.response.likes.map(function (like) { return like.user; });
                            this.showUsersLikedModal();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_4 = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.likedUsersLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.showUsersLikedModal = function () {
        var modal = this.$refs.usersLikedModal;
        if (modal === null || modal === void 0 ? void 0 : modal.show) {
            modal.show();
        }
    };
    App.prototype.consentWithCookies = function () {
        var cookieName = window.Config.cookie.name;
        var cookieValue = '1';
        var expirationDays = 730; // 2 years
        var domain = window.Config.cookie.domain;
        var secure = window.Config.cookie.session_secure;
        var sameSite = window.Config.cookie.session_same_site;
        var date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        var cookieString = cookieName + "=" + cookieValue + ";" + expires + ";path=/;domain=" + domain + (secure ? ';secure' : '') + (sameSite ? ";samesite=" + sameSite : '');
        document.cookie = cookieString;
        this.hideCookieDialog();
    };
    App.prototype.cookieExists = function (name) {
        return document.cookie.split(';').some(function (item) { return item.trim().startsWith(name + "="); });
    };
    App.prototype.hideCookieDialog = function () {
        var dialogs = document.getElementsByClassName('js-cookie-consent');
        for (var i = 0; i < dialogs.length; ++i) {
            var dialog = dialogs[i];
            dialog.style.display = 'none';
        }
        this.hideDialog();
    };
    App.prototype.showCookieDialog = function () {
        this.$store.state.modal.isModalOpen = true;
        this.$nextTick(function () {
            var dialog = document.querySelector('.js-cookie-consent');
            if (dialog) {
                dialog.focus();
            }
        });
    };
    App.prototype.setCookie = function (name, value, expirationInDays) {
        var date = new Date();
        date.setTime(date.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/;domain=" + window.Config.cookie.domain + (window.Config.cookie.session_secure ? ';secure' : '') + (window.Config.cookie.session_same_site ? ';samesite=' + window.Config.cookie.session_same_site : '');
    };
    App.prototype.getCookie = function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            // @ts-ignore
            return parts.pop().split(';').shift();
        }
    };
    App.prototype.hideDialog = function () {
        this.$store.state.modal.isModalOpen = false;
    };
    App.prototype.checkMobileView = function () {
        this.isMobileView = window.innerWidth <= 991;
    };
    App.prototype.created = function () {
        var activeElement = document.activeElement;
        this.initialFocusedElementId = activeElement ? activeElement.id : '';
    };
    App.prototype.mounted = function () {
        var _this_1 = this;
        this.$nextTick(function () {
            if (_this_1.initialFocusedElementId) {
                var elementToFocus = document.getElementById(_this_1.initialFocusedElementId);
                if (elementToFocus && (elementToFocus instanceof HTMLInputElement || elementToFocus instanceof HTMLTextAreaElement)) {
                    elementToFocus.focus();
                    // Now TypeScript knows setSelectionRange is available
                    if (['text', 'search', 'URL', 'tel', 'password'].includes(elementToFocus.type)) {
                        elementToFocus.setSelectionRange(elementToFocus.value.length, elementToFocus.value.length);
                    }
                }
            }
        });
        this.checkMobileView();
        window.addEventListener('resize', this.checkMobileView);
        if (this.cookieExists(window.Config.cookie.name)) {
            this.hideCookieDialog();
        }
        else {
            this.showCookieDialog();
        }
        var buttons = document.getElementsByClassName('js-cookie-consent-agree');
        for (var i = 0; i < buttons.length; ++i) {
            buttons[i].addEventListener('click', function () {
                _this_1.consentWithCookies();
            });
        }
        this.$root.$on('refreshAuthenticatedUser', function () {
            // maybe use store action directly where we emit this root event
            _this_1.$store.dispatch(ACTIONS.LOAD_SESSION);
        });
        this.$root.$on('clearNotifications', function () {
            // maybe use store action directly where we emit this root event
            _this_1.$store.dispatch(ACTIONS.CLEAR_NOTIFICATIONS);
        });
        this.$root.$on('showLikesModal', function (postUuid) {
            _this_1.loadAndShowPostLikes(postUuid);
        });
        this.$root.$on('addShowMenuClass', function () {
            _this_1.isMobileMenuOpen = !_this_1.isMobileMenuOpen;
        });
        this.$root.$on('hideShowMenuClass', function () {
            _this_1.isMobileMenuOpen = false;
        });
        this.$root.$on('updateSessionCounts', function () {
            _this_1.updateSessionCounts();
        });
        this.$root.$on('updateNotificationCounts', function () {
            _this_1.updateNotificationCounts();
        });
    };
    App.prototype.beforeDestroy = function () {
        window.removeEventListener('resize', this.checkMobileView);
    };
    __decorate([
        Provide(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], App.prototype, "session", null);
    App = __decorate([
        Component({
            store: store,
            router: router,
            i18n: i18n,
            apolloProvider: apolloProvider,
            components: { BrandBar: BrandBar, MobileBrandBar: MobileBrandBar, SearchBar: SearchBar, SideNav: SideNav, MobileSideNav: MobileSideNav, UserBar: UserBar, NotificationsBar: NotificationsBar, MainStage: MainStage, SimpleUsersModal: SimpleUsersModal, TimeoutManagerModal: TimeoutManagerModal, StaticPageAccordian: StaticPageAccordian, NeighbourhoodList: NeighbourhoodList, CommunityList: CommunityList, CommunityInformation: CommunityInformation, NeighbourhoodInformation: NeighbourhoodInformation, MembershipInformation: MembershipInformation, JumpLink: JumpLink },
        })
    ], App);
    return App;
}(Vue));
export default App;
var app = new App();
app.$mount('#app');
